import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import content from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { fab,faTwitterSquare, faFacebook, faLinkedin, faInstagramSquare, faYoutube, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

import Tinybox from "vue-tinybox";
Vue.component('Tinybox', Tinybox);

var urlCommon=window.location.origin+"/website";

//Vue.prototype.$urlCommon = 'http://localhost:8082/website';
//Vue.prototype.$urlCommon = "http://192.168.29.131:8081/website";
//Vue.prototype.$urlCommon = 'https://uat.apdclrms.com/website';
//  Vue.prototype.$urlCommon = 'https://www.apdcl.org/website';
 Vue.prototype.$urlCommon = urlCommon;


// Vue.prototype.$urlArms = 'https://uat.apdclrms.com/cbs';
// Vue.prototype.$urlRestapi = 'https://uat.apdclrms.com/restapi';
// Vue.prototype.$urlMyBijulee = 'https://uat.apdclrms.com/myBijulee';


Vue.prototype.$urlArms = 'https://www.apdclrms.com/cbs';
Vue.prototype.$urlRestapi = 'https://www.apdcl.org/restapi';
Vue.prototype.$urlMyBijulee = 'https://www.apdclrms.com/myBijulee';


library.add(faFacebook, faTwitterSquare, faLinkedin, faInstagramSquare, faPhone, faEnvelope,faYoutube,faTwitter)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(content)
}).$mount('#app')
